export default __webpack_public_path__ + "static/media/Huge-ProjectsDekstop.013aaaaa.jpg";